import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useCreateInconsistencies = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const createInconsistencies = async () => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/inconsistency`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to create inconsistencies');
    }
    return response.json();
  };

  return useMutation({
    mutationFn: createInconsistencies,
    onSuccess: () => {
      toast.success('Creating inconsistencies... you will receive an email when this is complete.');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Case, caseId] });
    },
    onError: () => {
      toast.error('Failed to create inconsistencies');
    },
  });
};
